import { fromJS } from 'immutable'
import {
  CONSENT_MANAGEMENT_EXPORT_REQUEST,
  CONSENT_MANAGEMENT_EXPORT_SUCCESS,
  CONSENT_MANAGEMENT_EXPORT_FAILURE,
  CONSENT_MANAGEMENT_EXPORT_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case CONSENT_MANAGEMENT_EXPORT_REQUEST:
      return state
        .set('isFetching', true)
    case CONSENT_MANAGEMENT_EXPORT_SUCCESS:
      return state
        .set('url', fromJS(action.payload.url))
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_EXPORT_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case CONSENT_MANAGEMENT_EXPORT_RESET:
      return state
        .delete('url')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/consent-management/consent-management-export-reducer.js